export const timeToMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number)
    return hours * 60 + minutes
}

export const isTimeSameOrAfter = (time: string, breakStartTime: string): boolean => {
    return timeToMinutes(time) >= timeToMinutes(breakStartTime)
}

export const isTimeBefore = (time: string, shiftStartTime: string): boolean => {
    return timeToMinutes(time) < timeToMinutes(shiftStartTime)
}

export const isTimeInBreakTime = (time: string, breakStartTime?: string, breakEndTime?: string): boolean => {
    if (!breakStartTime || !breakEndTime) {
        return false
    }

    return timeToMinutes(time) > timeToMinutes(breakStartTime) && timeToMinutes(time) < timeToMinutes(breakEndTime)
}
